import React, { useContext, useState } from 'react'
import { TrackerDetailsContext } from 'pages/policyCenter/trackers/context'
import { InfoRow, TextInput } from '@ketch-com/deck'
import { useIsPermitted } from 'utils/hooks/useIsPermitted'
import { PERMISSIONS } from 'interfaces/permissions/permissions'
import { LanguageDTO } from 'interfaces/languages/language'

type DisclosureTranslationsProps = {
  language: LanguageDTO
}
export const DisclosureTranslations: React.FC<DisclosureTranslationsProps> = ({ language }) => {
  const { isPermitted: getIsPermitted } = useIsPermitted()
  const isPermittedToWriteCookie = getIsPermitted([PERMISSIONS.COOKIE_WRITE])
  const {
    encodedTrackerKey = '',
    updateTrackerDisclosure,
    isUpdatingTrackerDisclosure,
    disclosure,
  } = useContext(TrackerDetailsContext)
  const description = disclosure?.[language?.code]?.description
  const [isEditing, setIsEditing] = useState(false)
  const [currentDisclosure, setCurrentDisclosure] = useState<string>(description)
  const [previousDisclosure, setPreviousDisclosure] = useState<string>('')

  return (
    <InfoRow
      title={language?.englishName}
      isEditable={isPermittedToWriteCookie ? true : false}
      isEditing={isEditing}
      isLoading={isUpdatingTrackerDisclosure}
      onEditChange={() => {
        setIsEditing(true)
        setPreviousDisclosure(description)
      }}
      onAcceptChange={() => {
        updateTrackerDisclosure({
          params: {
            requestBody: { ...disclosure, [language.code]: { description: currentDisclosure } },
            encodedTrackerKey,
          },
        })
        setIsEditing(false)
      }}
      onCancelChange={() => {
        setCurrentDisclosure(previousDisclosure)
        setIsEditing(false)
      }}
      onDeleteChange={() => {
        updateTrackerDisclosure({
          params: { requestBody: { ...disclosure, [language.code]: { description: '' } }, encodedTrackerKey },
        })
        setIsEditing(false)
      }}
      isEmpty={!!!description?.length}
    >
      {isEditing ? (
        <TextInput
          autoFocus
          placeholder="None"
          multiline={true}
          rows={2}
          fullWidth={true}
          value={currentDisclosure}
          onChange={event => setCurrentDisclosure(event.target.value)}
        />
      ) : description ? (
        description
      ) : (
        'None'
      )}
    </InfoRow>
  )
}
